import { render, staticRenderFns } from "./unloadPipeDetail.vue?vue&type=template&id=0bb117b4&"
import script from "./unloadPipeDetail.vue?vue&type=script&lang=js&"
export * from "./unloadPipeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports